import { render } from "./CubeBinome.vue?vue&type=template&id=b27e07b2&scoped=true"
import script from "./CubeBinome.vue?vue&type=script&lang=js"
export * from "./CubeBinome.vue?vue&type=script&lang=js"

import "./CubeBinome.vue?vue&type=style&index=0&id=b27e07b2&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b27e07b2"]])

export default __exports__